import instance from '@/utils/instance';

//文件列表
export function getFilesPreview(params) {
	return instance({
		url: `/webL_api/third/files/preview/${params}`,
		method: 'get'
	});
}

//获取结构化文档目录
export function getFilesDocmentCatalogDet(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/findDocmentCatalog/${params.docmentId}`,
		method: 'get'
	});
}

//根据章节ID获取章节详情
export function getFilesDocmentClauseInfo(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/getClauseInfo/${params}`,
		method: 'post'
	});
}

//获取结构化文档列表
export function getFilesDocmentFindBookJsonList(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/findBookJsonList`,
		method: 'get'
	});
}

//根据ID查询文档题录信息
export function getFilesDocmentFindDocment(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/findDocment/${params}`,
		method: 'get'
	});
}

//按页获取结构化数据
export function getFilesDocmentFindDocmentPageJson(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/findDocmentPageJson/${params.docmentId}?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
		method: 'get'
	});
}

//根据文档ID获取文档所有页码
export function getFindDocmentPage(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/findDocmentPage/${params}`,
		method: 'get'
	});
}

//获取文档页码数据
export function getFindDocmentPageInfo(params) {
	return instance({
		url: `/webW_api/tgtwipe/api/json/findDocmentPageInfo/${params.docId}/${params.pageIds}`,
		method: 'get'
	});
}

//文件下载检查
export function getDownloadCheck(params) {
	return instance({
		url: `/webL_api/consumer/order/downloadCheck/${params}`,
		method: 'get'
	});
}

//文件阅读检查
export function getReadCheck(params) {
	return instance({
		url: `/webL_api/consumer/order/checkHas?standardId=${params}`,
		method: 'get'
	});
}

//文档内-全文检索(特种设备)
export function getDocumentFull(params) {
	return instance({
		url: `/webL_api/essential/api/getDocumentFull`,
		method: 'post',
		data: params
	});
}

